// extracted by mini-css-extract-plugin
export default {"zoomModal":"J2-z","image":"K2-z","button":"L2-z","isOverlayShown":"M2-z"};